var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Heard'),_c('div',{staticClass:"container-fluid login-box"},[_c('div',{staticClass:"container write-box"},[_c('el-card',[_c('div',[_c('router-link',{staticStyle:{"color":"#000"},attrs:{"to":"/login"}},[_vm._v("返回")])],1),_c('div',{staticStyle:{"width":"160px","height":"160px"},attrs:{"id":"wx_box"}})])],1)]),_c('Otherfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }